import React from 'react'

import useText from '../common/hooks/useText'
import { Dropdown, DropdownProps } from '../common/uikit/Dropdown'

const DISABLED_VALUE = 0

export const MIN_SAFE_CURRENT = 6
export const MAX_SAFE_CURRENT = 32
export const SCHUKO_CURRENT = 10

const CurrentSelect = ({
    value,
    disabled,
    minValue = MIN_SAFE_CURRENT,
    maxValue,
    onChange,
    placeholder,
    isSocket,
    error,
    ...props
}: Props): React.ReactElement => {
    const text = useText()
    const currentValues: number[] = []
    if (typeof maxValue === 'number') {
        for (let i = minValue; i <= maxValue; i++) currentValues.push(i)
    }
    const dropdownOptions = [
        {
            label: isSocket ? text('lblOff') : text('lblDisabledStatus'),
            value: DISABLED_VALUE,
        },
        ...currentValues.map((current) => ({
            label: isSocket
                ? text('lblSocketChargingOnStatus', { currentLimit: SCHUKO_CURRENT })
                : `${current} ${text('lblAmpereShort')}`,
            value: current,
        })),
    ]

    if (value && maxValue && value > maxValue && !isSocket) {
        dropdownOptions.push({
            label: `${value} A`,
            value: value,
        })
    }

    return (
        <Dropdown
            value={value}
            placeholder={placeholder}
            options={dropdownOptions}
            onChange={onChange}
            disabled={disabled}
            error={error}
            // option and value need to set manually, because of the way Dropdown works with "0" value
            optionLabel="label"
            optionValue="value"
            id="current-select"
            {...props}
        />
    )
}

export default CurrentSelect

export type Props = Omit<DropdownProps, 'id'> & {
    minValue?: number
    maxValue?: number
    isSocket?: boolean
}
